import { useMemo } from "react"

import { useTranslation } from "@bounce/i18n"

import type { CityData } from "@/libs/bounce/cities"
import type { ArticleType, FormattedBlogPost } from "@/libs/prismic/types"
import type { Breadcrumb } from "@/types"

export const useBreadcrumbs = ({
  article,
}: {
  type: ArticleType
  article: FormattedBlogPost
  city?: CityData | null
  poiSlug?: string
}): Breadcrumb[] => {
  const { t } = useTranslation("marketing-generic")

  const breadcrumbs = useMemo(() => {
    const home = {
      id: "home",
      name: t("page.article.breadcrumbs.home", "Home"),
      href: "/",
    }

    // Blog post
    return [
      home,
      {
        id: "blog",
        name: t("page.article.breadcrumbs.blog", "Blog"),
        href: "/blog",
      },
      {
        id: "article",
        name: article.title,
        href: `/blog/${article.uid}`,
      },
    ]
  }, [article.title, article.uid, t])

  return breadcrumbs
}
